<template>
  <transition name="fade" appear>
    <div
      class="Loading fixed top-0 left-0 h-screen w-screen z-50 bg-navy-deep bg-opacity-75"
      v-show="state.active"
    >
      <VStack spacing="center" align="center" class="px-4">
        <AnimatedSprite sprite-id="loading-logo" class="w-64 h-64" />
        <div class="-mt-12 font-semibold tracking-wide">
          {{ state.text }}
        </div>
      </VStack>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useLoading } from '.'

export interface Options {
  closable?: 'also' | 'only'
  type?: 'dark' | 'light' | 'red'
  onClose?: () => unknown
  time?: number
}

export default defineComponent({
  name: 'Loading',
  setup() {
    const state = useLoading()

    return {
      state,
    }
  },
})
</script>

<style lang="scss" scoped>
.Loading {
  will-change: transform, opacity;
}

.slide-left {
  &-enter-active,
  &-leave-active {
    transition: opacity 50ms ease-in-out;
  }
  &-enter-from,
  &-leave-to {
    opacity: 0;
  }
}
</style>
